var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-179a43e0"), n = n(), _popScopeId(), n); };
var _hoisted_1 = ["aria-disabled", "aria-orientation", "aria-valuemax", "aria-valuemin"];
var _hoisted_2 = { class: "e-range-slider__marks" };
import SliderButton from './components/Button.vue';
import SliderMarker from './components/Marker.vue';
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ERangeSlider',
    props: {
        value: { default: 0 },
        min: { default: 0 },
        max: { default: 100 },
        step: { default: 1 },
        inputSize: { default: 'small' },
        showStops: { type: Boolean },
        showTooltip: { type: Boolean, default: true },
        formatTooltip: {},
        disabled: { type: Boolean },
        range: { type: Boolean },
        vertical: { type: Boolean },
        height: {},
        debounce: { default: 300 },
        label: {},
        tooltipClass: {},
        marks: {}
    },
    emits: ["change", "input"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var rootRef = ref();
        var sliderRef = ref();
        var button1Ref = ref();
        var firstValue = ref();
        var secondValue = ref();
        var oldValue = ref();
        var dragging = ref(false);
        var sliderSize = ref(1);
        var stops = computed(function () {
            if (!props.showStops || props.min > props.max)
                return [];
            if (props.step === 0) {
                process.env.NODE_ENV !== 'production' &&
                    console.warn('[ERangeSlider] Step should not be 0.');
                return [];
            }
            var stopCount = (props.max - props.min) / props.step;
            var stepWidth = 100 * props.step / (props.max - props.min);
            var result = [];
            for (var i = 1; i < stopCount; i++) {
                result.push(i * stepWidth);
            }
            return props.range ? result.filter(function (step) {
                return step < 100 * (minValue.value - props.min) / (props.max - props.min) ||
                    step > 100 * (maxValue.value - props.min) / (props.max - props.min);
            }) : result.filter(function (step) { return step > 100 * (firstValue.value - props.min) / (props.max - props.min); });
        });
        var markList = computed(function () {
            if (!props.marks) {
                return [];
            }
            var marksKeys = Object.keys(props.marks);
            return marksKeys.map(function (mark) { return parseFloat(mark); })
                .sort(function (a, b) { return a - b; })
                .filter(function (point) { return point <= props.max && point >= props.min; })
                .map(function (point) { return ({
                point: point,
                position: (point - props.min) * 100 / (props.max - props.min),
                mark: props.marks[point]
            }); });
        });
        var minValue = computed(function () {
            return Math.min(firstValue.value, secondValue.value);
        });
        var maxValue = computed(function () {
            return Math.max(firstValue.value, secondValue.value);
        });
        var barSize = computed(function () {
            return props.range
                ? "".concat(100 * (maxValue.value - minValue.value) / (props.max - props.min), "%")
                : "".concat(100 * (firstValue.value - props.min) / (props.max - props.min), "%");
        });
        var barStart = computed(function () {
            return props.range
                ? "".concat(100 * (minValue.value - props.min) / (props.max - props.min), "%")
                : '0%';
        });
        var precision = computed(function () {
            var precisions = [props.min, props.max, props.step].map(function (item) {
                var decimal = ('' + item).split('.')[1];
                return decimal ? decimal.length : 0;
            });
            return Math.max.apply(null, precisions);
        });
        var runwayStyle = computed(function () {
            return props.vertical ? { height: props.height } : {};
        });
        var barStyle = computed(function () {
            return props.vertical
                ? {
                    height: barSize.value,
                    bottom: barStart.value
                } : {
                width: barSize.value,
                left: barStart.value
            };
        });
        var sliderDisabled = computed(function () {
            return props.disabled;
        });
        watch(function () { return props.value; }, function (val, oldVal) {
            if (dragging.value ||
                Array.isArray(val) &&
                    Array.isArray(oldVal) &&
                    val.every(function (item, index) { return item === oldVal[index]; })) {
                return;
            }
            setValues();
        });
        watch(dragging, function (val) {
            if (!val) {
                setValues();
            }
        });
        watch(firstValue, function (val) {
            if (props.range) {
                emit('input', [minValue.value, maxValue.value]);
            }
            else {
                emit('input', val);
            }
        });
        watch(secondValue, function (val) {
            if (props.range) {
                emit('input', [minValue.value, maxValue.value]);
            }
        });
        watch(function () { return props.min; }, function (val) {
            setValues();
        });
        watch(function () { return props.max; }, function (val) {
            setValues();
        });
        onMounted(function () {
            var valuetext;
            if (props.range) {
                if (Array.isArray(props.value)) {
                    firstValue.value = Math.max(props.min, props.value[0]);
                    secondValue.value = Math.min(props.max, props.value[1]);
                }
                else {
                    firstValue.value = props.min;
                    secondValue.value = props.max;
                }
                oldValue.value = [firstValue.value, secondValue.value];
                valuetext = "".concat(firstValue.value, "-").concat(secondValue.value);
            }
            else {
                firstValue.value = typeof props.value !== 'number' || isNaN(props.value) ? props.min : Math.min(props.max, Math.max(props.min, props.value));
                oldValue.value = firstValue.value;
                valuetext = firstValue.value;
            }
            rootRef.value.setAttribute('aria-valuetext', valuetext);
            // label screen reader
            rootRef.value.setAttribute('aria-label', props.label ? props.label : "\u0441\u043B\u0430\u0439\u0434\u0435\u0440 \u043C\u0435\u0436\u0434\u0443 ".concat(props.min, " \u0438 ").concat(props.max));
            resetSize();
            window.addEventListener('resize', resetSize);
        });
        onBeforeUnmount(function () {
            window.removeEventListener('resize', resetSize);
        });
        var valueChanged = function () {
            return props.range ? ![minValue.value, maxValue.value]
                .every(function (item, index) { return item === oldValue.value[index]; }) : props.value !== oldValue.value;
        };
        var setValues = function () {
            if (props.min > props.max) {
                console.error('[ERangeSlider] Min should not be greater than max.');
                return;
            }
            var val = props.value;
            if (props.range && Array.isArray(val)) {
                if (val[1] < props.min) {
                    emit('input', [props.min, props.min]);
                }
                else if (val[0] > props.max) {
                    emit('input', [props.max, props.max]);
                }
                else if (val[0] < props.min) {
                    emit('input', [props.min, val[1]]);
                }
                else if (val[1] > props.max) {
                    emit('input', [val[0], props.max]);
                }
                else {
                    firstValue.value = val[0];
                    secondValue.value = val[1];
                    if (valueChanged()) {
                        oldValue.value = __spreadArray([], __read(val), false);
                    }
                }
            }
            else if (!props.range && typeof val === 'number' && !isNaN(val)) {
                if (val < props.min) {
                    emit('input', props.min);
                }
                else if (val > props.max) {
                    emit('input', props.max);
                }
                else {
                    firstValue.value = val;
                    if (valueChanged()) {
                        oldValue.value = val;
                    }
                }
            }
        };
        var setPosition = function (percent) {
            var targetValue = props.min + percent * (props.max - props.min) / 100;
            if (!props.range) {
                button1Ref.value.setPosition(percent);
                return;
            }
            var button;
            if (Math.abs(minValue.value - targetValue) < Math.abs(maxValue.value - targetValue)) {
                button = firstValue.value < secondValue.value ? 'button1' : 'button2';
            }
            else {
                button = firstValue.value > secondValue.value ? 'button1' : 'button2';
            }
            if (button === 'button1') {
                button1Ref.value.setPosition(percent);
            }
        };
        var onSliderClick = function (event) {
            if (sliderDisabled.value || dragging.value)
                return;
            resetSize();
            if (props.vertical) {
                var sliderOffsetBottom = sliderRef.value.getBoundingClientRect().bottom;
                setPosition((sliderOffsetBottom - event.clientY) / sliderSize.value * 100);
            }
            else {
                var sliderOffsetLeft = sliderRef.value.getBoundingClientRect().left;
                setPosition((event.clientX - sliderOffsetLeft) / sliderSize.value * 100);
            }
            emitChange();
        };
        var resetSize = function () {
            if (sliderRef.value) {
                sliderSize.value = sliderRef.value["client".concat(props.vertical ? 'Height' : 'Width')];
            }
        };
        var emitChange = function () {
            nextTick(function () {
                emit('change', props.range ? [minValue.value, maxValue.value] : props.value);
            });
        };
        var getStopStyle = function (position) {
            return props.vertical ? { 'bottom': position + '%' } : { 'left': position + '%' };
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "rootRef",
                ref: rootRef,
                "aria-disabled": sliderDisabled.value,
                "aria-orientation": _ctx.vertical ? 'vertical' : 'horizontal',
                "aria-valuemax": _ctx.max,
                "aria-valuemin": _ctx.min,
                class: _normalizeClass([{ 'is-vertical': _ctx.vertical }, "e-range-slider"]),
                role: "slider"
            }, [
                _createElementVNode("div", {
                    ref_key: "sliderRef",
                    ref: sliderRef,
                    class: _normalizeClass([{ 'disabled': sliderDisabled.value }, "e-range-slider__runway"]),
                    style: _normalizeStyle(runwayStyle.value),
                    onClick: onSliderClick
                }, [
                    _createElementVNode("div", {
                        style: _normalizeStyle(barStyle.value),
                        class: "e-range-slider__bar"
                    }, null, 4),
                    _createVNode(SliderButton, {
                        ref_key: "button1Ref",
                        ref: button1Ref,
                        value: firstValue.value,
                        "emit-change": emitChange,
                        "format-tooltip": _ctx.formatTooltip,
                        max: _ctx.max,
                        min: _ctx.min,
                        precision: precision.value,
                        "reset-size": resetSize,
                        "show-tooltip": _ctx.showTooltip,
                        "slider-disabled": sliderDisabled.value,
                        "slider-size": sliderSize.value,
                        step: _ctx.step,
                        onChangeDragging: _cache[0] || (_cache[0] = function ($event) { return (dragging.value = $event); }),
                        onInput: _cache[1] || (_cache[1] = function ($event) { return (firstValue.value = $event); })
                    }, null, 8, ["value", "format-tooltip", "max", "min", "precision", "show-tooltip", "slider-disabled", "slider-size", "step"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stops.value, function (item, key) {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                            (_ctx.showStops)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    style: _normalizeStyle(getStopStyle(item)),
                                    class: "e-range-slider__stop"
                                }, null, 4))
                                : _createCommentVNode("", true)
                        ], 64));
                    }), 128)),
                    (markList.value.length > 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markList.value, function (item, key) {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: key,
                                        style: _normalizeStyle(getStopStyle(item.position)),
                                        class: "e-range-slider__stop e-range-slider__marks-stop"
                                    }, null, 4));
                                }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_2, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markList.value, function (item, key) {
                                    return (_openBlock(), _createBlock(SliderMarker, {
                                        key: key,
                                        mark: item.mark,
                                        style: _normalizeStyle(getStopStyle(item.position))
                                    }, null, 8, ["mark", "style"]));
                                }), 128))
                            ])
                        ], 64))
                        : _createCommentVNode("", true)
                ], 6)
            ], 10, _hoisted_1));
        };
    }
});
